module.exports = __webpack_public_path__ + "img/logo.885ef206.png";